module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authorised",
    class: {
      'authorised--hidden': !_vm.active
    },
    on: {
      "click": function($event) {
        _vm.toggleAuthorised(false)
      }
    }
  }, [_c('div', {
    staticClass: "authorised__container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "authorised__stamp_up"
  }), _vm._v(" "), _c('div', {
    staticClass: "authorised__stamp_down"
  }), _vm._v(" "), _c('div', {
    staticClass: "authorised__text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('legalH1')))]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('legalP1')) + "\n      "), _c('br'), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('legalP2')) + "\n      "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('legalH2')))]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('legalP3')) + "\n      "), _c('br'), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('legalP4')) + "\n      "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "authorised__item"
  }, [_c('span', {
    staticClass: "authorised__check icon-checkmark"
  }), _vm._v(_vm._s(_vm.$t('legalL1')))]), _vm._v(" "), _c('div', {
    staticClass: "authorised__item"
  }, [_c('span', {
    staticClass: "authorised__check icon-checkmark"
  }), _vm._v(_vm._s(_vm.$t('legalL2')))]), _vm._v(" "), _c('div', {
    staticClass: "authorised__item"
  }, [_c('span', {
    staticClass: "authorised__check icon-checkmark"
  }), _vm._v(_vm._s(_vm.$t('legalL3')))]), _vm._v(" "), _c('div', {
    staticClass: "authorised__item"
  }, [_c('span', {
    staticClass: "authorised__check icon-checkmark"
  }), _vm._v(_vm._s(_vm.$t('legalL4')))]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('legalP5')) + "\n      "), _c('br'), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('legalP6')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "authorised__close icon-close",
    on: {
      "click": function($event) {
        _vm.toggleAuthorised(false)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53edae8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overview/partials/Authorised.vue
// module id = 413
// module chunks = 1